import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { PendingWorkingHourFlat } from '../../../../api/types/accountants/salaries-pending-payments-flat/pending-working-hour-flat.type';

const toYyyyMmDd = (date: Date) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const noop = () => null;

export const generatePayrollReportFlatOperation = async (
  userIds: number[],
  branchIds: number[],
  startTime: Date,
  endTime: Date,
  includeRetroactivePayments: boolean,
  setLoading: (loading: boolean) => void,
  setPendingWorkingHours: (
    pendingWorkingHours: PendingWorkingHourFlat[],
  ) => void,
  setTotal: (total: number) => void = noop,
  offset = 0,
  limit = 1000,
) => {
  try {
    setLoading(true);
    const res = await appApi.generatePayrollReportFlat(
      userIds,
      branchIds,
      toYyyyMmDd(startTime),
      toYyyyMmDd(endTime),
      includeRetroactivePayments,
      offset,
      limit,
    );
    setPendingWorkingHours(res.data.body.data as PendingWorkingHourFlat[]);
    setTotal(res.data.body.total);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  } finally {
    setLoading(false);
  }
};
